export default __webpack_public_path__ + "static/media/sinusoid-properties.ed6c4092.gif";